angular.module('filters')
    .filter('default', () => (value, defaultValue) => value || defaultValue);



// WEBPACK FOOTER //
// ./scripts/common/filters/default.js